// extracted by mini-css-extract-plugin
export default {"container":"I1-z","list":"J1-z"};